import angular from 'angular';

const $inject = ['moment', '$filter', 'ENUMS', 'dateTimeService', 'settingsService'];

const sectorChangeService = function sectorChangeService(moment, $filter, ENUMS, dateTimeService, settingsService) {
  return {
    initializeChangeSector,
    getSelectedFlightCancelSegments,
    getSelectedCancelSectors,
  };

  function initializeChangeSector(sectorKey, $scope) {
    switch (sectorKey) {
      case 'flight':
        initializeFlights($scope);
        break;
      case 'car':
        if (!$scope.changeSectorIdentifier) return;
        initializeCar($scope);
        break;
      case 'hotel':
        if (!$scope.changeSectorIdentifier) return;
        initializeHotel($scope);
        break;
    }
  }

  function initializeTraveler($scope) {
    let travelerInfo = { traveler: null, otherTravelers: null, changeSector: null };
    $scope.itinerary.itineraryModel.Passengers.forEach((pax, i) => {
      var findSector = $scope.changeSectorIdentifier
        ? pax.Sectors.find((s) => s.Identifier == $scope.changeSectorIdentifier)
        : i === 0
        ? pax.Sectors[0]
        : null;
      if (findSector) {
        $scope.changeSector = findSector;
        travelerInfo.changeSector = findSector;
        travelerInfo.traveler = pax;
        travelerInfo.otherTravelers = $scope.itinerary.itineraryModel.Passengers.filter((p) => p.Identifier !== pax.Identifier);
        let selTraveler = $scope.addTravelers.find((t) => t.Identifier == pax.Identifier);
        $scope.selectedTravelers.push(selTraveler);
      }
    });

    return travelerInfo;
  }

  function initializeHotel($scope) {
    var travelerInfo = initializeTraveler($scope);
    if (travelerInfo.otherTravelers.length) {
      travelerInfo.changeSector.linkedSectors = [];
      travelerInfo.otherTravelers.forEach((pax) => {
        let matchingSector = pax.Sectors.find((s) => isSameHotel(s, travelerInfo.changeSector));
        if (matchingSector) {
          travelerInfo.changeSector.linkedSectors.push({ sector: matchingSector.Identifier, passenger: pax.Identifier });
          let pTravel = $scope.addTravelers.find((t) => t.Identifier == pax.Identifier);
          if (!$scope.selectedTravelers.includes(pTravel)) $scope.selectedTravelers.push(pTravel);
        }
      });
    }
  }
  function isSameHotel(hotel1, hotel2) {
    if (!hotel1 || !hotel1.HotelName || !hotel2 || !hotel2.HotelName) return false;
    if (hotel1.HotelName !== hotel2.HotelName) return false;
    if (hotel1.DateFrom !== hotel2.DateFrom) return false;
    if (hotel1.DateTo !== hotel2.DateTo) return false;

    return true;
  }

  function initializeCar($scope) {
    var travelerInfo = initializeTraveler($scope);
    if (travelerInfo.otherTravelers.length) {
      travelerInfo.changeSector.linkedSectors = [];
      travelerInfo.otherTravelers.forEach((pax) => {
        let matchingSector = pax.Sectors.find((s) => isSameCar(s, travelerInfo.changeSector));
        if (matchingSector) {
          travelerInfo.changeSector.linkedSectors.push({ sector: matchingSector.Identifier, passenger: pax.Identifier });
          let pTravel = $scope.addTravelers.find((t) => t.Identifier == pax.Identifier);
          if (!$scope.selectedTravelers.includes(pTravel)) $scope.selectedTravelers.push(pTravel);
        }
      });
    }
  }
  function isSameCar(car1, car2) {
    if (!car1 || !car1.PickUp || !car2 || !car2.PickUp) return false;
    if (car1.PickUp.Code !== car2.PickUp.Code) return false;
    if (car1.PickUp.Date !== car2.PickUp.Date) return false;
    if (car1.DropOff.Code !== car2.DropOff.Code) return false;
    if (car1.DropOff.Date !== car2.DropOff.Date) return false;
    if (car1.Supplier.Code !== car2.Supplier.Code) return false;

    return true;
  }

  function initializeFlights($scope) {
    $scope.flightsSelected = [];
    $scope.changeSector = null;

    var travelerInfo = initializeTraveler($scope);
    travelerInfo.traveler.Sectors.filter(
      (sector) => sector.FlightNumber && (sector.Status == 'CurrentItin' || sector.Status == 'Pending')
    ).forEach((sector) => {
      sector.cancelCurrent = sector.Identifier === $scope.changeSectorIdentifier;
      sector.TktorExchTkt = sector.TicketNumber ? sector.TicketNumber : sector.ExchangeTicketNumber;
      sector.itemIndex = $scope.flightsSelected.length;
      $scope.flightsSelected.push(sector);
      sector.linkedSectors = [];
      let isChangeSector = sector.Identifier === $scope.changeSectorIdentifier;
      if (travelerInfo.otherTravelers.length) {
        travelerInfo.otherTravelers.forEach((pax) => {
          let matchingSector = pax.Sectors.find((s) => isSameFlight(s, sector));
          if (matchingSector) {
            sector.linkedSectors.push({ sector: matchingSector.Identifier, passenger: pax.Identifier });
            let pTravel = $scope.addTravelers.find((t) => t.Identifier == pax.Identifier);
            if (isChangeSector && !$scope.selectedTravelers.includes(pTravel)) $scope.selectedTravelers.push(pTravel);
          }
        });
      }

      if (isChangeSector) $scope.changeSector = sector;
    });
  }
  function getSelectedCancelSectors($scope) {
    let cancelSectors = [$scope.changeSectorIdentifier];
    if ($scope.changeSector && $scope.changeSector.linkedSectors) {
      $scope.changeSector.linkedSectors.forEach((l) => {
        if ($scope.selectedTravelers.find((d) => d === l.passenger)) {
          cancelSectors.push(l.sector);
        }
      });
    }
    return cancelSectors;
  }
  function isSameFlight(flight1, flight2) {
    if (!flight1 || !flight1.FlightNumber || !flight2 || !flight2.FlightNumber) return false;
    if (flight1.FlightIdentifier && flight2.FlightIdentifier) {
      return flight1.FlightIdentifier == flight2.FlightIdentifier;
    }
    if (flight1.Departure.Code !== flight2.Departure.Code) return false;
    if (flight1.Departure.Date !== flight2.Departure.Date) return false;
    if (flight1.Arrival.Code !== flight2.Arrival.Code) return false;
    if (flight1.Arrival.Date !== flight2.Arrival.Date) return false;
    if (flight1.FlightNumber !== flight2.FlightNumber) return false;
    if (flight1.Carrier !== flight2.Carrier) return false;
    if (flight1.GdsProvider !== flight2.GdsProvider) return false;
    if (flight1.GDSSegmentNumber !== flight2.GDSSegmentNumber) return false;

    return true;
  }
  function getSelectedFlightCancelSegments($scope) {
    let flightsChange = [];
    if ($scope && $scope.flightsSelected) {
      $scope.flightsSelected
        .filter((flight) => flight.cancelCurrent)
        .forEach((flight) => {
          flightsChange.push(flight.Identifier);
          if (flight.linkedSectors) {
            flight.linkedSectors.forEach((l) => {
              if ($scope.selectedTravelers && $scope.selectedTravelers.find((d) => d === l.passenger)) {
                flightsChange.push(l.sector);
              }
            });
          }
        });
    }
    return flightsChange;
  }
};
sectorChangeService.$inject = $inject;

export default sectorChangeService;



// WEBPACK FOOTER //
// ./src/services/sectorChangeService.js